import { request } from "utils/api";
import { ContactData, ReducedUserProfileWithEmail } from "./user";

// alias account settings
export interface AliasAccountSettings {
    allow3rdPartyCheckIns: boolean,
}

// fetch alias accounts (GET /alias-accounts)
export const getAliasAccounts = (data: {
    clubId: string,
}) => request<ReducedUserProfileWithEmail[]>({
    data,
    endpoint: "/alias-accounts",
    method: "get",
});

// create an alias account connected to user (POST /alias-accounts)
export const postAliasAccounts = (data: {
    aliasName: string,
    clubId: string,
}) => request<ReducedUserProfileWithEmail>({
    data,
    endpoint: "/alias-accounts",
    method: "post",
});

// delete alias accounts (DELETE /alias-accounts)
export const deleteAliasAccounts = (data: {
    aliasUserIds: string[],
}) => request<{}>({
    data,
    endpoint: "/alias-accounts",
    method: "delete",
});

// fetch whether alias account is available (GET /alias-accounts/check)
export const getAliasAccountsAvailable = (data: {
    aliasName: string,
}) => request<{ available: boolean, email: string }>({
    data,
    endpoint: "/alias-accounts/check",
    method: "get",
});

// create an alias account connected to the club (POST /admin/alias-accounts)
export const postAdminAliasAccounts = (data: {
    clubId: string,
    emailPrefix: string,
    firstName: string,
    lastName: string,
}) => request<{ user: ReducedUserProfileWithEmail, password: string }>({
    data,
    endpoint: "/admin/alias-accounts",
    method: "post",
});

// retrieve alias account contact data (GET /alias-accounts/contact-data)
export const getAliasAccountsContactData = (data: {
    aliasUserId: string,
}) => request<ContactData>({
    data,
    endpoint: "/alias-accounts/contact-data",
    method: "get",
});

// create or update alias account contact data (PUT /alias-accounts/contact-data)
export const putAliasAccountsContactData = (data: ContactData & {
    aliasUserId: string
}) => request<ContactData>({
    data,
    endpoint: "/alias-accounts/contact-data",
    method: "put",
});

// fetch alias account settings (GET /alias-accounts/settings)
export const getAliasAccountsSettings = (data: {
    aliasUserId: string,
}) => request<AliasAccountSettings>({
    data,
    endpoint: "/alias-accounts/settings",
    method: "get",
});

// update alias account settings (PATCH /alias-accounts/settings)
export const patchAliasAccountsSettings = (data: {
    aliasUserId: string,
    allow3rdPartyCheckIns?: boolean,
}) => request<AliasAccountSettings>({
    data,
    endpoint: "/alias-accounts/settings",
    method: "patch",
});
